import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {SessionattendancesListHeader} from './components/header/SessionattendancesListHeader'
import {SessionattendancesTable} from './table/SessionattendancesTable'
import {SessionattendanceEditModal} from './sessionattendance-edit-modal/SessionattendanceEditModal'
import { KTCard } from '../../../../_metronic/helpers'
// import {KTCard} from '../../../../../_metronic/helpers'

const SessionattendancesList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        {/* <SessionattendancesListHeader /> */}
        <SessionattendancesTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <SessionattendanceEditModal />}
    </>
  )
}

const SessionattendancesListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <SessionattendancesList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {SessionattendancesListWrapper}
